<mat-card class="daxa-card mb-25 border-radius bg-white border-none d-block purple-theme">
  <mat-card-header>
    <mat-card-title>Obrazac B2 - Proračun</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    @if (budgetPlanForm) {
      <form [formGroup]="budgetPlanForm">
        <!-- DIRECT COSTS -->
        <h3>POGLAVLJE A) IZRAVNI TROŠKOVI</h3>
        <mat-accordion formArrayName="directCosts">
          @for (budgetItem of directCosts.controls; track budgetItem; let i = $index) {
            <mat-expansion-panel #directPanel  [formGroupName]="i">
              <mat-expansion-panel-header class="no-wrap-header">
                <mat-panel-title>
                  {{ budgetItem.get('description')?.value || 'Izravna stavka troška ' + (i + 1) }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="actions">
                <button mat-icon-button color="primary" (click)="closePanel(directPanel)" matTooltip="Završi uređivanje stavke" [disabled]="budgetItem.invalid">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="removeBudgetItem(budgetType.Direct, i)" matTooltip="Ukloni stavku">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <mat-form-field class="mb-25">
                <mat-label>Vrsta troška</mat-label>
                <textarea #directDescriptionInputs matInput formControlName="description"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Iznos tražen od Općine (EUR)</mat-label>
                <input matInput formattedNumber  [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amountRequested" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Ukupan iznos troška (EUR)</mat-label>
                <input matInput formattedNumber  [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="totalAmount" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Objašnjenje proračunske stavke</mat-label>
                <textarea matInput formControlName="explanation"></textarea>
              </mat-form-field>
              <app-file-upload
                [storageLocation]="budgetItem.get('fileStorageLocation')?.value"
              ></app-file-upload>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" (click)="addBudgetItem(budgetType.Direct)" [disabled]="budgetPlanForm.invalid">
          Dodaj Izravni Trošak
        </button>
        <div class="totals">
          <h4>
            Ukupno POGLAVLJE A) IZRAVNI TROŠKOVI (traženo / ukupno):
            {{ totalDirectCostsRequested | currency:'EUR' }} / {{ totalDirectCostsActual | currency:'EUR' }}
          </h4>
        </div>
        <mat-divider></mat-divider>
        <!-- INDIRECT COSTS -->
        <h3>POGLAVLJE B) NEIZRAVNI TROŠKOVI</h3>
        <mat-accordion formArrayName="indirectCosts">
          @for (budgetItem of indirectCosts.controls; track budgetItem; let i = $index) {
            <mat-expansion-panel #indirectPanel [formGroupName]="i" >
              <mat-expansion-panel-header class="no-wrap-header">
                <mat-panel-title>
                  {{ budgetItem.get('description')?.value || 'Neizravna stavka troška ' + (i + 1) }}
                </mat-panel-title>
              </mat-expansion-panel-header>
              <div class="actions">
                <button mat-icon-button color="primary" (click)="closePanel(indirectPanel)" matTooltip="Završi uređivanje stavke" [disabled]="budgetItem.invalid">
                  <mat-icon>check</mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="removeBudgetItem(budgetType.Indirect, i)" matTooltip="Ukloni stavku">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
              <mat-form-field class="mb-25">
                <mat-label>Vrsta troška</mat-label>
                <textarea #indirectDescriptionInputs matInput formControlName="description"></textarea>
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Iznos tražen od Općine (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amountRequested" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Ukupan iznos troška (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="totalAmount" />
              </mat-form-field>
              <mat-form-field class="mb-25">
                <mat-label>Objašnjenje proračunske stavke</mat-label>
                <textarea matInput formControlName="explanation"></textarea>
              </mat-form-field>
              <app-file-upload
                [storageLocation]="budgetItem.get('fileStorageLocation')?.value"
              ></app-file-upload>
            </mat-expansion-panel>
          }
        </mat-accordion>
        <button mat-raised-button color="primary" (click)="addBudgetItem(budgetType.Indirect)" [disabled]="budgetPlanForm.invalid">
          Dodaj neizravni trošak
        </button>
        <div class="totals">
          <h4>
            Ukupno POGLAVLJE B) NEIZRAVNI TROŠKOVI (traženo / ukupno):
            {{ totalIndirectCostsRequested | currency:'EUR' }} / {{ totalIndirectCostsActual | currency:'EUR' }}
          </h4>
        </div>
        <mat-divider></mat-divider>
        <div class="totals">
          <h3>
            SVEUKUPNO (A + B) (traženo / ukupno):
            {{ totalCostsRequested | currency:'EUR' }} / {{ totalCostsActual | currency:'EUR' }}
          </h3>
        </div>
        <mat-divider></mat-divider>
        <h3>OSTALI IZVORI FINANCIRANJA</h3>
        <div formArrayName="fundingSources">
          @for (fundingSource of fundingSources.controls; track fundingSource; let i = $index) {
            <div [formGroupName]="i" class="funding-source">
              <mat-form-field class="mb-25">
                <mat-label>{{ getFundingSourceLabel(fundingSource.get('type')?.value) }} (EUR)</mat-label>
                <input matInput formattedNumber [config]="{ decimals: 2, useThousands: true, maxDigits: 10 }" formControlName="amount" />
              </mat-form-field>
            </div>
          }
        </div>
        <div class="totals">
          <h4>SVEUKUPNO (I + II + III + IV): {{ totalFundingFromOtherSources | currency:'EUR' }}</h4>
        </div>
        <mat-divider></mat-divider>
        <div class="totals">
          <h3>SVEUKUPNI IZNOS TROŠKOVA PROGRAMA / PROJEKTA - SVI IZVORI: {{ totalFunding | currency:'EUR' }}</h3>
        </div>
        <app-budget-plan-status
          [totalCostsRequested]="totalCostsRequested"
          [totalCostsActual]="totalCostsActual"
          [totalFundingFromOtherSources]="totalFundingFromOtherSources"
          >
        </app-budget-plan-status>
      </form>
    }
  </mat-card-content>
</mat-card>